import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getModeDePaiement } from '../../../features/payement/payementSlice';
import { links } from '../../../utils/constants';
import Layout from '../../layout/Layout';

const ModeDePaiementPage = () => {
    const {state} = useLocation();
    let navigate = useNavigate()
    const dispatch = useDispatch()
    const { moyens } = useSelector(
        (state) => state.payement
    )
    const moyenChoice = (moyen) => {
        navigate(links.paiement, {
            state: {
                moyen: moyen,
                client: state.client,
            }
        })
    }
    useEffect(() => {
      dispatch(getModeDePaiement(state.pays))
      
    }, [dispatch, state.pays])
    
    return (

        <Layout>
            <div className='ipay-ui-page__title'>
                <h1>Payement via IventPay</h1>
                <span>Veuillez choisir le moyen de paiement</span>
            </div>
            <div className='ipay-ui-page__container'>
                {
                    moyens ? (
                        <div className='ipay-ui-page__form'>
                            {
                                moyens.results.length > 0 ? (
                                    <div className='ipay-ui-page__mode--grid'>
                                        {
                                            moyens.results.map((moyen, index) => (
                                                <div className='ipay-ui-page__mode--item' key={index}>
                                                    <button type='button' onClick={() => moyenChoice(moyen.id)}>
                                                        <img src={moyen.usr_logo} alt={moyen.nom + "-logo"} />
                                                        <span>{moyen.nom}</span>
                                                    </button>
                                                </div>
                                            ))
                                        }
                                        
                                    </div>
                                ) : ("Aucun moyen de paiement disponible")
                            }
                        </div>
                    ) : ("Chargement...")
                }
            </div>
        </Layout>
    );
};

export default ModeDePaiementPage;